'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var linkedListUtils = require('./linked-list-utils.js');

const findLinkedList = (predicate, list) => (linkedListUtils.walkListItemRecord((acc, item) => {
    if (predicate(item)) {
        return {
            result: item,
            control: {
                stop: true,
            },
        };
    }
    return {
        result: acc,
    };
}, {
    initValue: null,
    items: list.items,
    startId: list.headId,
}));

exports.findLinkedList = findLinkedList;
//# sourceMappingURL=find-linked-list.js.map
